export default "../../src/img/lunivers-small.svg";